import AddressLabelCell from './container';

export default AddressLabelCell;
